import { render } from "./initial-info.vue?vue&type=template&id=2e62eb82"
import script from "./initial-info.vue?vue&type=script&lang=js"
export * from "./initial-info.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__